//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  angular.module('curalate').directive('datatableLoadingOverlay', () => ({
    restrict: 'E',
    scope: {
      loading: '=',
    },
    template: '<div ng-class="{\'loading-overlay\': loading}"></div>',
  }));
})();
